import detectLang from 'toxilibs/language_detector.js'
import translate from 'toxilibs/translate.js'
import urlParams from 'toxilibs/url_params.js'
import translations from './translations.js'

let params = urlParams()

let defaultCodeLang = 'pseudo-code'

if (params.progression === 'python') {
    defaultCodeLang = 'python'
}

let {codeLang = defaultCodeLang} = params

const {pseudoCodeWords, otherWords} = translations


let translationsToUse = otherWords

if (codeLang === 'pseudo-code') {
    Object.assign(translationsToUse, pseudoCodeWords)
}


translate.init(translationsToUse, detectLang({
    accepted: ['fr', 'en', 'de', 'ro', 'es', 'ca', 'id', 'pt', 'it', 'tr', 'pl'],
    default: 'en'
}))
